import { render, staticRenderFns } from "./CustomerPage.vue?vue&type=template&id=2ae677ca&scoped=true&"
import script from "./CustomerPage.vue?vue&type=script&lang=js&"
export * from "./CustomerPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPage.vue?vue&type=style&index=0&id=2ae677ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae677ca",
  null
  
)

export default component.exports